import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { CtaButton } from './CtaButton';
const benefits = ['Plan na 16 tygodni, który mówi Ci, czego uczyć w każdym tygodniu', '3 ścieżki (początkujący, średniozaawansowany, wyzwanie), żeby ogarnąć wszystkich uczniów', '50 gotowych ćwiczeń jazzowych do druku', '6 kompletnych tomów z teorią, żeby wyjaśnić każde zagadnienie, nawet jeśli jazz nie jest Twoją specjalnością', 'Wszystko gotowe do użycia: wchodzisz, patrzysz i uczysz — bez żadnych przygotowań'];
export function SystemOverview() {
  return <section aria-labelledby="system-heading" className="bg-night py-14 sm:py-24" data-id="element-413" data-mp="13wpdicoxsukm">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-414" data-mp="yx330b0htsfi">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16" data-id="element-415" data-mp="yvi7oj6cu5gl">
          <div data-id="element-416" data-mp="2f9rtp6n4ji49">
            <Eyebrow data-id="element-417" data-mp="2f9i59nhq9j0o">Przedstawiamy</Eyebrow>
            <h2 id="system-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-418" data-mp="2acrmutigabc3">
              Arsenał Nauczyciela Jazzu&trade;:{' '}
              <span className="text-amber" data-id="element-419" data-mp="284o1x9n23gcd">cały semestr gotowy do uczenia</span>
            </h2>
            <p className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-420" data-mp="2d4adzfr5eqjl">
              Semestr gitary jazzowej zaplanowany tydzień po tygodniu. Otwierasz plan, widzisz temat
              tygodnia, drukujesz ćwiczenie dopasowane do poziomu ucznia i uczysz. Wyjaśnienia czekają
              już gotowe w części teoretycznej.
            </p>
          </div>
          <div className="lg:pt-10" data-id="element-421" data-mp="1uec5iyjfuvff">
            <ul className="space-y-4" data-id="element-422" data-mp="1udaj5xwz2mie">
              {benefits.map(item => <li key={item} className="flex items-start gap-3" data-id="element-423" data-mp="1z50vg9fgzkcg">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-deep" data-id="element-424" data-mp="11penmwj530n7">
                    <CheckIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-425" data-mp="16nyffdkez6nh" />
                  </span>
                  <span className="text-sm leading-relaxed text-cream-soft sm:text-base" data-id="element-426" data-mp="ymqohdft4i5f">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-427" data-mp="tmuu85www532">
              <CtaButton size="lg" data-id="element-428" data-mp="18dv2a9tqxwyo">Chcę gotowy semestr</CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}